import { Row } from 'antd';

const HVRow = props => {
    return <Row {...props} />;
};

export default HVRow;
